import type { AddressFieldsApi } from "@fluid-app/address-fields/address-fields-api";
import { fetchAddressFields } from "@/networking/addresses.api";

export function createAddressFieldsAdapter(): AddressFieldsApi {
  return {
    fetchAddressFields: (countryCode, languageIso) =>
      fetchAddressFields(countryCode, languageIso ?? "en"),
  };
}
